{
  "name": "breathing-star",
  "doc": "A radial zoom the music breathes through (the beat pushes it), with a bias that pulls more at the edge than in the centre (zoomexp > 1). The CIRCLE wave becomes concentric breathing.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.014,
  "zoomexp": 1.06,
  "rot": 0.0,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.96,
  "invert": 0,
  "hueShift": 0.004,
  "darkenCenter": 0.2,
  "wave": "CIRCLE",
  "waveColor": 0,
  "shapes": 1,
  "energy": [
    0.4,
    0.9
  ]
}